import { render, staticRenderFns } from "./Proechart.vue?vue&type=template&id=0a1aa328&"
import script from "./Proechart.vue?vue&type=script&lang=js&"
export * from "./Proechart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports